import { render } from "./CourseTeacher.vue?vue&type=template&id=019caf5f"
import script from "./CourseTeacher.vue?vue&type=script&lang=js"
export * from "./CourseTeacher.vue?vue&type=script&lang=js"

import "./CourseTeacher.vue?vue&type=style&index=0&id=019caf5f&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__